import { Dialog } from 'primereact/dialog';
import styled from 'styled-components';

export const Modal = styled(Dialog)`
  border-radius: 20px;
  overflow: hidden;

  /* Mobile: add outer spacing so dialog doesn't touch screen edges */
  @media (max-width: 768px) {
    width: calc(100vw - 32px) !important;
    max-width: calc(100vw - 32px) !important;
    margin: 16px !important;
  }

  /* Mobile: for some NewRelease modals we want edge-to-edge */
  @media (max-width: 768px) {
    &.no-mobile-margin {
      width: 100vw !important;
      max-width: 100vw !important;
      margin: 0 !important;
    }
  }
`;
